import React from 'react';
import { motion } from 'framer-motion';
import { LandingForm } from './LandingForm';
import { GameAliases } from './GameAliases';

export function Hero() {
  return (
    <section
      className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 relative"
      style={{
        backgroundImage:
          'url(https://upload.wikimedia.org/wikipedia/commons/3/3c/People_playing_card_games_in_the_street.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-white/90" />

      {/* Content above overlay */}
      <div className="relative z-10 max-w-6xl mx-auto py-12 px-4">
        {/* Heading - spans full width */}
        <motion.div
          initial={{
            opacity: 0,
            x: -20,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 0.6,
          }}
          className="text-left mb-4"
        >
          <h1 className="text-4xl sm:text-5xl font-bold text-black mb-2 tracking-tight">
            升级
          </h1>
          <h2 className="text-xl font-semibold text-black mb-6">Shengji</h2>
        </motion.div>

        {/* Two-column grid for content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Left side - Description and form */}
          <motion.div
            initial={{
              opacity: 0,
              x: -20,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.6,
            }}
            className="w-full"
          >
            <p className="text-base sm:text-lg text-gray-600 max-w-sm leading-relaxed mb-6">
              The classic Chinese trick-taking card game. Create or join a room
              to play with friends
            </p>

            <LandingForm />
          </motion.div>

          {/* Right side - Cards */}
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.9,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              duration: 0.6,
              delay: 0.3,
            }}
            className="flex items-start justify-center lg:justify-end lg:pr-8"
          >
            <GameAliases />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
